import {
    call,
    put,
    takeLatest,
} from 'redux-saga/effects';
import axios from 'axios';
import {
    CREATE_TICKET,
    DELETE_TICKET,
    GET_TICKET_SETTINGS,
    FETCH_ORDER_INFO,
    LIST_ISSUE_ACTION_SPECIFIC_TASKS,
    LIST_ISSUE_SPECIFIC_ACTIONS,
    LIST_ISSUE_SPECIFIC_TASKS,
    LIST_TICKET_ISSUES,
    LIST_TICKETS,
    LIST_STATUS,
    PREVIEW_TICKET_FILE,
    UPDATE_TICKET, UPDATE_TICKET_SETTINGS, GENERATE_RETURN_REDIRECT, RETURN_REDIRECT_TRACKING_STATUS, DELETE_RETURN_REDIRECT,
    CALCULATE_TICKET_REFUND_AMOUNT,
} from '../../constants/tickets';
import { clearStatus, requestStatus, hideError, showErrorMessage } from "../../actions/global";
import { PURCHASE_ORDERS, RETURNS, TICKETS } from "../../../components/global/Server/endpoints";
import { HTTP_SUCCESS } from "../../constants/global";
import { storeReturns, storeUpdatedReturn, storeUpdatedReturnWithPreview } from "../../actions/returns";
import {
    storeOrderInfoFetch,
    storeTicketActions,
    storeTicketActionTasks,
    storeTicketIssues,
    storeTickets,
    storeUpdatedTicket,
    storeTicketSettings,
    storeUpdatedTicketWithPreview,
    storeStatus,
    updateTicket,
    storeTicketRefundAmount,
    storeReturnRedirect,
    storeReturnRedirectTrackingStatus,
    clearReturnRedirectTrackingNumber,
    getTicketSettings,
} from '../../actions/tickets';
import {
    ORDER_INFO_NOT_MAPPED,
    RMA_NOT_MAPPED,
    SERVER_FAILED_ERROR_MESSAGE,
} from '../../../pages/Dashboard/DashboardFinal/constants';
import {storeResponseMessage} from "../../actions/settings";
import {storeRedirectSettings} from "../../actions/automationRules";

const getHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        "Authorization": `Bearer ${token}`
    }
}

const postRequest = (endpoint, data) => {
    return axios.post(endpoint, data, {
        headers: getHeaders()
    })
        .then(response => response)
}

const getRequest = (endpoint) => {
    return axios.get(endpoint, {
        headers: getHeaders()
    })
        .then(response => response);
}

function* listTicketsSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.LIST_TICKETS, action.data))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeTickets(response.data))
        yield put(requestStatus(status))
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* createTicketSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.CREATE_TICKET, action.newTicket))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (!response.data.success) {
            yield put(showErrorMessage(response.data.message));
        } else {
            const newGeneralTicketFiles = anyUpdatedFiles(action.newTicket, true, true)

            if (newGeneralTicketFiles.length !== 0) {
                const response2 = yield call(() => postRequest(TICKETS.ADD_FILES, {
                    files: newGeneralTicketFiles,
                    ticketId: response.data.ticket.ticketId, actionFiles: false
                }))
                const status2 = {
                    status: response2.status,
                    statusText: response2.statusText,
                    success: response2.status === HTTP_SUCCESS,
                };
                if (!response2.data.success) {
                    yield put(showErrorMessage(response2.data.message));
                } else {
                    yield put(storeUpdatedTicket(response2.data.ticket))
                }
                yield put(requestStatus(status2))
            } else {
                yield put(storeUpdatedTicket(response.data.ticket))
                yield put(requestStatus(status))
            }

            yield action.reset()
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function anyUpdatedFiles(updatedTicket, newFiles, generalFile) {
    if (generalFile) {
        if (newFiles)
            return updatedTicket.newFiles
        return updatedTicket.deletedFiles
    }
    else {
        let updatedActionFiles = {}
        // go through each action of the ticket to check if the new files is not empty
        updatedTicket.actions.forEach((ticketAction) => {

            if (newFiles) {
                if (ticketAction.newFiles && ticketAction.newFiles.length !== 0){
                    if (ticketAction.actionName == 'Send Redirect Label'){
                        updatedActionFiles[ticketAction.actionName] = {file: ticketAction.newFiles, redirectLabelId: ticketAction.redirectLabelId}
                    }else if(ticketAction.actionName == 'Send Return Label'){
                        updatedActionFiles[ticketAction.actionName] = {file: ticketAction.newFiles, returnTrackingId: ticketAction.returnTrackingId}
                    } else{
                        updatedActionFiles[ticketAction.actionName] = {file: ticketAction.newFiles}
                    }
                }
            }
            else if (ticketAction.deletedFiles) {
                if (ticketAction.deletedFiles.length !== 0)
                    if (ticketAction.actionName == 'Send Redirect Label'){
                        updatedActionFiles[ticketAction.actionName] = {file: ticketAction.deletedFiles, redirectLabelId: ticketAction.redirectLabelId}
                    }else if(ticketAction.actionName == 'Send Return Label'){
                        updatedActionFiles[ticketAction.actionName] = {file: ticketAction.deletedFiles, returnTrackingId: ticketAction.returnTrackingId}
                    } else{
                        updatedActionFiles[ticketAction.actionName] = {file: ticketAction.deletedFiles}
                    }
            }

        })

        return updatedActionFiles
    }


}

// when we initally update the ticket, we dont care about the files, we want to isolate these calls
function removeFileInfo(ticket) {
    ticket.actions.forEach((action, index) => {
        /*if(action["deletedFiles"]){
            ticket.actions[index].files =  ticket.actions[index].prevFilesCopy
        }*/
        ticket.actions[index].files = action.files.filter((file) => {
            return !("byteArray" in file)
        })
        delete action["newFiles"]
        delete action["deletedFiles"]
        delete action["prevFilesCopy"]
    })
    delete ticket.files
    delete ticket.newFiles
    delete ticket.deletedFiles
    return ticket
}

function* deleteTicketSaga(action) {
    try {
        const response = yield postRequest(TICKETS.DELETE_TICKET, {ticketId: action.ticketId})

        if (response.data.success) {
            try {
                action.callback()
            } catch (e) {
                yield put(showErrorMessage("Update Ticket Callback Failed"));
            }
        } else {
            yield put(showErrorMessage(response.data.message));
        }

    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* getTicketSettingsSaga() {
    yield put(hideError())
    try {
        const response = yield call(() => getRequest(TICKETS.GET_TICKET_SETTINGS))

        if (response.data && response.data[0] && response.data[0].ticketSettings) {
            yield put(storeTicketSettings(response.data[0].ticketSettings));
        }

    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* updateTicketSettingsSaga(action) {
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(TICKETS.UPDATE_TICKET_SETTINGS, action))

        if (response.data?.success) {
            yield put(storeTicketSettings(response.data.ticketSettings[0].ticketSettings));
        }

    } catch (error) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

function* updateTicketSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const newGeneralTicketFiles = anyUpdatedFiles(action.updatedTicket, true, true)

        const deletedGeneralTicketFiles = anyUpdatedFiles(action.updatedTicket, false, true)

        const newActionFiles = anyUpdatedFiles(action.updatedTicket, true, false)

        const deletedActionFiles = anyUpdatedFiles(action.updatedTicket, false, false)

        const noFileTicket = removeFileInfo(action.updatedTicket)

        const response = yield call(() => postRequest(TICKETS.UPDATE_TICKET, {
            ticket: action.updatedTicket,
            deletedGeneralTicketFiles: deletedGeneralTicketFiles, newGeneralTicketFiles: newGeneralTicketFiles,
            deletedActionFiles:deletedActionFiles, newActionFiles: newActionFiles}))

        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (!response.data.success) {
            yield put(showErrorMessage(response.data.message));
        }
        yield put(storeUpdatedTicket(response.data.ticket))
        yield put(requestStatus(status));

    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* listTicketIssuesSaga() {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => getRequest(TICKETS.LIST_TICKET_ISSUES))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeTicketIssues(response.data))
        yield put(requestStatus(status))
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* listStatusSaga() {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => getRequest(TICKETS.LIST_STATUS))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        yield put(storeStatus(response.data))
        yield put(requestStatus(status))
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}



function* listIssueSpecificTasksSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.LIST_ISSUE_ACTION_SPECIFIC_TASKS, action.ticketIssueId))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };

        yield put(storeTicketActionTasks(response.data))
        yield put(requestStatus(status));
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}


function* listIssueSpecificActionsSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.LIST_ISSUE_SPECIFIC_ACTIONS, action.ticketIssueId))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };


        yield put(storeTicketActions(response.data))
        yield put(requestStatus(status));
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}


function* previewTicketFileSaga(action) {
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.PREVIEW_FILE, action.previewRequest))
        const status = {
            status: response.status,
            statusText: response.statusText,
            success: response.status === HTTP_SUCCESS,
        };
        if (!response.data.success) {
            yield put(showErrorMessage(response.data.message));
        } else {

            if (action.callback && typeof action.callback === 'function') {
                const files = response?.data?.ticket?.files;

                if (Array.isArray(files) && files.length > 0 && files[0]?.previewFile) {
                    let previewData = new Uint8Array(files[0].previewFile);
                    action.callback(previewData);
                }
            }

            yield put(storeUpdatedTicketWithPreview(response.data.ticket))
        }
        yield put(requestStatus(status))
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* fetchOrderInfo(action){
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.FETCH_ORDER_INFO, action))
        if(response.data.success) {
            yield put(storeOrderInfoFetch(response.data))

        } else{
            yield put(showErrorMessage(ORDER_INFO_NOT_MAPPED));
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* calculateTicketRefundAmountSaga(action){
    yield call(clearStatus)
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(TICKETS.CALCULATE_REFUND, action.data))
        if(response.data.success) {
            const {refundAmount, refundDetails} = response.data;
            yield put(storeTicketRefundAmount(action.index, refundAmount, refundDetails))
        } else{
            yield put(showErrorMessage(response.data.message));
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* generateReturnRedirect(action){
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.GENERATE_RETURN_REDIRECT, action.data))
        if(response.data.success) {
            yield put(storeReturnRedirect(response.data))
            yield put(storeResponseMessage(response.data?.message))
        } else{
            yield put(showErrorMessage(response.data.message));
        }
        action.callback(response.data)
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}


function* returnRedirectTrackingStatus(action){
    yield call(clearStatus)
    yield put(hideError());
    try {
        const response = yield call(() => postRequest(TICKETS.RETURN_REDIRECT_TRACKING_STATUS, action.data))
        if(response.data.success) {
            yield put(storeReturnRedirectTrackingStatus(response.data))
        } else{
            yield put(storeReturnRedirectTrackingStatus(response.data))
            //yield put(showErrorMessage(response.data.message));
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE));
    }
}

function* deleteReturnRedirect(action){
    yield call(clearStatus)
    yield put(hideError())
    try {
        const response = yield call(() => postRequest(TICKETS.DELETE_RETURN_REDIRECT, action.data))
        if(response.data.success) {
            if (action.callback) {
                action.callback(null, response.data)
            }
            yield put(storeResponseMessage(response.data?.message))
        } else{
            if (action.callback) {
                action.callback(response.data.message);
            }
            yield put(showErrorMessage(response.data.message))
        }
    } catch (e) {
        yield put(showErrorMessage(SERVER_FAILED_ERROR_MESSAGE))
    }
}

export default function* ticketsSagas() {
    yield takeLatest(CREATE_TICKET, createTicketSaga)
    yield takeLatest(LIST_TICKETS, listTicketsSaga)
    yield takeLatest(UPDATE_TICKET, updateTicketSaga)
    yield takeLatest(UPDATE_TICKET_SETTINGS, updateTicketSettingsSaga)
    yield takeLatest(DELETE_TICKET, deleteTicketSaga)
    yield takeLatest(GET_TICKET_SETTINGS, getTicketSettingsSaga)

    yield takeLatest(LIST_TICKET_ISSUES, listTicketIssuesSaga)
    yield takeLatest(LIST_STATUS, listStatusSaga)
    yield takeLatest(LIST_ISSUE_SPECIFIC_ACTIONS, listIssueSpecificActionsSaga)
    yield takeLatest(LIST_ISSUE_SPECIFIC_TASKS, listIssueSpecificTasksSaga)

    yield takeLatest(PREVIEW_TICKET_FILE, previewTicketFileSaga)
    yield takeLatest(FETCH_ORDER_INFO, fetchOrderInfo)
    yield takeLatest(GENERATE_RETURN_REDIRECT, generateReturnRedirect)
    yield takeLatest(RETURN_REDIRECT_TRACKING_STATUS, returnRedirectTrackingStatus)
    yield takeLatest(DELETE_RETURN_REDIRECT, deleteReturnRedirect)
    yield takeLatest(CALCULATE_TICKET_REFUND_AMOUNT, calculateTicketRefundAmountSaga)
}